import CustomDataTable from '@/components/organisms/CustomDataTable/CustomDataTable'
import {getCellDataMappedCols} from '@/helpers/dataTableCellDataMapper'
import {useRewardCatalog} from '@/hooks/useRewardCatalog'
import {useState} from 'react'
import { FileUploadWithModal } from '@/components/organisms'
import {useNavigate} from 'react-router-dom'
import {cellDataMapperObj} from './cellDataMapper'
import { REWARD_CATALOG_ROUTES, Constants, DISABLE_HEADERS, UPLOAD_TITLES, UPLOAD_ERROR_MESSAGES } from '@/utils/constants/commonConstants'
import { convertToLowerCase } from '@/utils/commons'
import { ROUTES } from '@/utils/constants/routesConstants'

export const RewardCatalogList = () => {
  const navigate = useNavigate()
  const [uploadFor, setUploadFor] = useState(null)
  const [rowSelected, setRowSelected] = useState([])
  const [isSelectAll, setIsSelectAll] = useState(false)
  
  const {
    rewardCatalogData,
    rewardCatalogColConfigData,
    pageIndex,
    customRules,
    customRulesRewards,
    uploading,
    uploadProgress,
    uploadErrorMessage,
    formData,
    setFormData,
    openUpload,
    setOpenUpload = () => {},
    setPageIndex,
    setSortingObj,
    sortingObj,
    setSearchArry,
    onDownloadBtnClick,
    isLoading,
    handleResetAll,
    dropdownList,
    handleDownloadTemplate,
    handleBulkUpload,
    setUploading,
    handleCloseNotification,
    handleCloseModal,
  } = useRewardCatalog()

  const cellDataMappedCols = getCellDataMappedCols(cellDataMapperObj(navigate), rewardCatalogColConfigData)

  const onDownloadClick = async () => {
    const ids = rowSelected.map(item => item?.rewardId || item?.uuid)
    onDownloadBtnClick(isSelectAll ? [] : ids)
  }

  const handleActionClick = action => {
    const displayText = convertToLowerCase(action?.displayText)
    switch (displayText) {
      case REWARD_CATALOG_ROUTES.NEW_REWARD:
        navigate(ROUTES.REWARDS_CREATE)
        break
      case REWARD_CATALOG_ROUTES.BULK_UPLOAD_REWARDS:
        setUploadFor(Constants.BulkRewards)
        setOpenUpload(true);
        break
      case REWARD_CATALOG_ROUTES.BULK_UPLOAD_DIGITAL_CODES:
        setUploadFor(Constants.BulkDigitalCodes)
        setOpenUpload(true);
        break
      case REWARD_CATALOG_ROUTES.DOWNLOAD:
        onDownloadClick()
        break
      default:
        break
    }
  }

  return (
    <div className="rewardCatalogDataTable w-full">     
      <CustomDataTable
        columns={cellDataMappedCols}
        records={rewardCatalogData?.data || []}
        isLoading={isLoading}
        pageSize={10}
        totalRecords={rewardCatalogData?.totalRecords}
        setPageIndex={setPageIndex}
        handleSorting={setSortingObj}
        setSearchArry={setSearchArry}
        onResetAll={handleResetAll}
        onRowSelect={(selectedRecords, isAll) => {
          setRowSelected(selectedRecords)
          setIsSelectAll(isAll)
        }}
        onDownload={onDownloadClick}
        actionItems={dropdownList}
        showActionMenu={true}
        onActionClick={actionItem => handleActionClick(actionItem)}
        isSelectAll={isSelectAll}
        pageIndex={pageIndex}
        initialSortConfig={sortingObj}
        disabledHeaders={DISABLE_HEADERS.REWARD_CATALOG_HEADERS}
      />
      {rewardCatalogData?.totalRecords > 0 && (
        <div className="txtRightAlign">{rewardCatalogData?.totalRecords} total items</div>
      )}
      <FileUploadWithModal
        title={uploadFor === Constants.BulkDigitalCodes ? UPLOAD_TITLES.UPLOAD_DIGITAL_CODES_LIST : UPLOAD_TITLES.UPLOAD_REWARDS_LIST}
        fileType="csv"
        uploadFor={uploadFor}
        openUpload={openUpload}
        uploading={uploading}
        setUploading={setUploading}
        uploadProgress={uploadProgress}
        uploadErrorMessage={uploadErrorMessage}
        setOpenUpload={setOpenUpload}
        setFormData={setFormData}
        formData={formData}
        customErrorMessages={{
          wrongFormat: UPLOAD_ERROR_MESSAGES.WRONG_FORMAT,
        }}
        showDownloadTemplate={true}
        handleDownloadTemplate={handleDownloadTemplate}
        customRules={uploadFor === Constants.BulkDigitalCodes ? customRules : customRulesRewards}
        isCsvValidationRequired={true}
        primaryButtonText= "Upload"
        subTitle=" "
        isPending={false}
        onClickPrimary={() => {
          handleBulkUpload(formData, uploadFor);
        }}
        primaryButtonDisabled={!formData?.storeList}
        handleCloseNotification={handleCloseNotification}
        handleCloseModal={handleCloseModal}
      />
    </div>
  )
}
